import { ListarGruposRepasseService } from "../../../Services/Repasse/EtapasGrupo/EtapasGrupoServices";
import { Controller } from "../../Controller";

export async function ListarGruposRepasseController() {
    return Controller(ListarGruposRepasseService());
}
